import * as React from 'react';
import { observer } from 'mobx-react';
import { style } from 'typestyle';
import { px } from 'csx';
import { Component, deps, inject } from '../../../lib/component';
import { colorSubtle, rebrand } from '../../../theme/color';
import { SUPPORT_HUB } from '../../../constants';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { Button } from '../atoms/button/Button';
import { ButtonProminence, ButtonSize } from '../atoms/button/buttonStyles';

export interface BasketRestrictedModalProps {
  show: boolean;
  onRequestClose(): void;
}

@inject(deps)
@observer
export class BasketErrorModal extends Component<BasketRestrictedModalProps> {
  render() {
    const { show, onRequestClose } = this.props;

    return (
      <ScrollableOverlay
        className={BasketErrorModal.styles.wrapper}
        show={show}
        onRequestClose={onRequestClose}
        aria-labelledby="basket-error-title"
      >
        <div className={overlayStyles.header}>
          <h3 className={overlayStyles.title} id="basket-error-title">
            Basket Error
          </h3>
        </div>
        <div className={BasketErrorModal.styles.body}>
          <p>
            Unfortunately, an error occurred when adding this track to your basket. Please{' '}
            <a href={SUPPORT_HUB} className={BasketErrorModal.styles.link}>
              contact support
            </a>{' '}
            if the issue persists.
          </p>
          <Button
            className={BasketErrorModal.styles.button}
            prominence={ButtonProminence.SECONDARY}
            size={ButtonSize.MEDIUM}
            onClick={onRequestClose}
          >
            Close
          </Button>
        </div>
      </ScrollableOverlay>
    );
  }

  static styles = {
    link: style({
      color: rebrand.contrast[40].toString(),
      textDecoration: 'underline',
    }),
    loading: style({
      padding: px(30),
      textAlign: 'center',
      color: colorSubtle.toString(),
    }),
    discount: style({
      textDecoration: 'line-through',
      marginRight: px(5),
    }),
    body: style(ScrollableOverlayBodyStyle, {
      padding: '1.5rem 0 0',
      borderTop: `1px solid ${rebrand.light1.toString()}`,
      textAlign: 'center',
      $nest: {
        '& > p': {
          margin: '0 0 1.5rem',
          textAlign: 'left',
          lineHeight: px(24),
        },
      },
    }),
    wrapper: style({ display: 'block', maxWidth: px(440) }),
    button: style({ width: px(128) }),
  };
}
